import MiOverlay from './MiOverlay.vue'

export default MiOverlay
